import { observer } from 'mobx-react-lite'
import { useState } from 'react'
import { Button, Card, Form, Modal, Spinner } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { useStore } from '../../app/stores/store'
import { toast } from 'react-toastify'
import { IconButton } from '@mui/material'

function EditCompanyName({ handleClose }: any) {
  const { profileStore, userStore } = useStore()
  const { getData } = userStore
  const [loadingBtn, setLoadingBtn] = useState(false)
  const { t } = useTranslation()
  const [company, setCompany] = useState({
    companyName: getData?.companyName || '',
    companyUrl: getData?.companyUrl || '',
  })

  const handleSubmit = (e: any) => {
    setLoadingBtn(true)
    e.preventDefault()

    if (
      (company.companyName && !company.companyUrl) ||
      (!company.companyName && company.companyUrl)
    ) {
      setLoadingBtn(false)
      toast.error('Please fill both Company\'s Name and Website')
    } else if (company.companyUrl && !isValidUrl(company.companyUrl)) {
      setLoadingBtn(false)
      toast.error('Please enter a valid URL starting with "https://" or "http://".')
    } else {
      profileStore.changeUserCompanyName(company).finally(() => {
        setLoadingBtn(false)
        toast.success('Company Info changed successfully')
        handleClose()
      })
    }
  }

  const isValidUrl = (url: string): boolean => {
    return url.startsWith('https://') || url.startsWith('http://')
  }

  const handleInputChange = (e: any) => {
    const { name, value } = e.target
    setCompany({ ...company, [name]: value })
  }

  const clearSearch = (name: string) => {
    setCompany({ ...company, [name]: '' })
  }

  const passwordField = [
    {
      label: 'Company Name',
      name: 'companyName',
      value: company.companyName,
      placeholder: 'Name',
    },
    {
      label: 'Company Website',
      name: 'companyUrl',
      value: company.companyUrl,
      placeholder: 'https://example.com',
    },
  ]

  const buttons = [
    {
      title: t('cancel'),
      onClick: handleClose,
      className: 'text-white payment-button-cancel',
      type: 'button',
    },
    {
      title: loadingBtn ? <Spinner animation='border' variant='light' /> : t('edit'),
      className: 'text-white payment-button-tryagain',
      type: 'submit',
    },
  ]

  return (
    <Card className='newFont prevent-select'>
      <Modal.Header>
        <p className='login-card-title'>{t('company_page.company_info_title')}</p>
        <Button variant='inherit' onClick={handleClose} className='close me-2'>
          <i className='fa-regular fa-x icon-size' />
        </Button>
      </Modal.Header>
      <Modal.Body className='card-padding card-font-size'>
        <Form onSubmit={handleSubmit}>
          <Form.Group className='mb-3 profile-password'>
            {passwordField.map((a, index) => (
              <div key={index}>
                <Form.Label className='login-p'>{a.label}</Form.Label>
                <div className='position-relative'>
                  <Form.Control
                    className='card-input-style'
                    type='text'
                    placeholder={a.placeholder}
                    value={a.value}
                    onChange={handleInputChange}
                    name={a.name}
                  />
                  {a.value && (
                    <div className='position-absolute top-50 end-0 translate-middle'>
                      <IconButton onClick={() => clearSearch(a.name)}>
                        <i className='fa-solid fa-xmark' />
                      </IconButton>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </Form.Group>
          <div className='auction-create-buttons'>
            {buttons.map((button, index) => (
              <button
                key={index}
                onClick={button.onClick}
                disabled={loadingBtn}
                type={button.type === 'submit' ? 'submit' : 'button'}
                className={`text-white ${button.className}`}
              >
                {button.title}
              </button>
            ))}
          </div>
        </Form>
      </Modal.Body>
    </Card>
  )
}
export default observer(EditCompanyName)
